import react from "react";
import moment from "moment";

const useLeads = (url) => {

    const getWeekAndDates = () => {
        const currentDate = moment();
        const startOfWeek = currentDate.clone().startOf("week");
        const endOfWeek = currentDate.clone().endOf("week");
        const dates = [],
            days = [];
        for (let i = 0; i <= 6; i++) {
            dates.push(moment(startOfWeek).add(i, "days").format("DD"));
            days.push(moment(startOfWeek).add(i, "days").format("ddd"));
        }
        return { dates, days };
    }

    return {
        getWeekAndDates
    }

};

export default useLeads;